// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "modal__content-3I9ms";
var _3 = "modal__header-2X98e";
var _4 = "modal__paper-S89be";
var _5 = "status-2C8sA";
var _6 = "status_accent-1pkb4";
var _7 = "passenger__segment-3MlvG";
var _8 = "services-1DWtq";
var _9 = "passenger-2Ds_F";
var _a = "passenger__name-2wNgA";
var _b = "notification__text-3C0TI";
var _c = "loader-1zo5t";
var _d = "removeServices-3Y648";
export { _1 as "__esModule", _2 as "modal__content", _3 as "modal__header", _4 as "modal__paper", _5 as "status", _6 as "status_accent", _7 as "passenger__segment", _8 as "services", _9 as "passenger", _a as "passenger__name", _b as "notification__text", _c as "loader", _d as "removeServices" }
export default { "__esModule": _1, "modal__content": _2, "modal__header": _3, "modal__paper": _4, "status": _5, "status_accent": _6, "passenger__segment": _7, "services": _8, "passenger": _9, "passenger__name": _a, "notification__text": _b, "loader": _c, "removeServices": _d }
